import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const agentsTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "agents",
};

export interface IAgentsTranslations {
  agents: (typeof agentsTranslations)["en"]["agents"];
}
